import {createSlice} from '@reduxjs/toolkit'

const highlightIndex = createSlice({
    name:"highlight",
    initialState:{
        index:0
    },
    reducers:{
        setIndex:(state,action)=>{
            console.log(action)
            console.log("consoled inside the highlight slice")
            state.index = action.payload.index
        },
    }
})

export const {setIndex} = highlightIndex.actions
export default highlightIndex.reducer